import { Button, Link, LoadingButton } from '@one-thd/sui-atomic-components';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { useReturnStore } from '../../stores/returnStore';
import { redirectToOrderDetails } from '../../utils/general';
export var ReturnButtons = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, proceedBack = _a.proceedBack, proceedNext = _a.proceedNext, _c = _a.final, final = _c === void 0 ? false : _c, _d = _a.instore, instore = _d === void 0 ? false : _d, _e = _a.isError, isError = _e === void 0 ? false : _e, _f = _a.loading, loading = _f === void 0 ? false : _f;
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var orderDetailsPath = useReturnStore(function (state) { return state.orderDetailsPath; });
    var nextButtonText = function () {
        if (final)
            return 'Confirm Return';
        if (instore)
            return 'Return to Order Details';
        if (isError)
            return 'Retry';
        return 'Continue';
    };
    return (React.createElement("div", { className: "sui-mt-8 sui-flex sui-flex-col sui-justify-end sui-items-center sm:sui-mt-15 sm:sui-flex-row" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4 sui-w-full sm:sui-w-auto sm:sui-flex-row-reverse" },
            React.createElement(LoadingButton, { variant: "primary", type: "button", onClick: function () { return proceedNext(); }, fullWidth: isMobile, disabled: disabled, loading: loading },
                React.createElement("span", null, nextButtonText())),
            proceedBack && (React.createElement(Button, { variant: "secondary", type: "button", onClick: function () { return proceedBack(); }, fullWidth: isMobile }, "Go Back"))),
        !instore && (React.createElement("div", { className: "sui-mt-7 sm:sui-order-first sm:sui-mt-0 sm:sui-mr-7" },
            React.createElement(Link, { onClick: function () {
                    return redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest);
                } }, "Cancel Return")))));
};
